<template>
  <div class="my-message all-order-content">
    <div class="breadcrumb" style="margin-bottom: 20px;">推荐产品</div>
    <div class="right-content">
      <el-form ref="form" label-width="160px" :model="form" :rules="rules" class="demo-form-inline">
        <div v-for="(item, index) in form.productList" :key="index">
          <el-form-item label="选择类型：" prop="relationId">
            <div style="display: flex;">
              <el-select v-model="item.productType" placeholder="请选择类型" clearable @change="item.productInfo = '', item.productId = 0, tableDataList[index].list = []">
                <el-option label="类" value="CATEGORY"></el-option>
                <el-option label="产品" value="SPU"></el-option>
                <el-option label="sku" value="SKU"></el-option>
              </el-select>
              <el-select style="width: 200px;margin-left: 20px;" suffix-icon="el-icon-date" clearable v-model="item.productInfo" :filter-method="(e) => filterMethod(e, index)" filterable
                placeholder="请输入产品类/产品名称/产品sku关键词搜索" @change="handleChange($event, index)">
                <el-option v-for="item in tableDataList[index].list" :key="item.id" :label="item.name" :value="item" :value-key="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item>
            <el-upload :ref="`uploadFile${index}`" :class="{ hide_uploadbtn: item.productUrl && item.productUrl.length > 0 }" action="#" list-type="picture-card" accept='image/jpeg'
              :on-preview="showPcImagePreview" :on-remove="(e) => removeAppImage(e, index)" :file-list.sync="item.productUrl" :http-request="(e) => uploadAppImage(e, index)" :multiple="false"
              :limit="1">
              <i class="el-icon-plus"></i>
            </el-upload>
            <p style="color: #999;line-height: 22px;">仅可上传一张图片</p>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button @click="continueAdd" round>继续 添加</el-button>
        </el-form-item>
        <el-form-item label="预览图：">
          <div style="padding: 5px 10px 5px 5px;border: 1px dashed #aaa;height: 100px;width:70%;">
            <el-image v-for="(item, index) in previewUrlList" :key="index" :ref="`imgSize${index}`" style="height: 100px;margin-left: 5px;" :src="item.url" :preview-src-list="[item.url]"
              @load="imageLoad($event, item.url, index)">
            </el-image>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save" round style="float: right;margin-right:10%;">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import uploadWebImg from '@/utils/uploadWebImg'
import { appRecmendSave, updateRecmendById, getRelatesInfo, getInfoRecmendById } from '@/api/pms'
export default {
  name: 'banner-detail',
  data () {
    return {
      previewUrlList: [],
      form: {
        name: '',
        previewUrl: '',
        productList: [
          {
            productId: 0,
            productInfo: '',
            productType: '',
            productUrl: []
          }
        ]
      },
      tableDataList: [{ list: [] }]
    }
  },
  async created () {
    if (this.$checkAwsSdk('product')) {
      this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    }
    if (this.$route.query.bannerDetail) {
      this.form = this.$route.query.bannerDetail
    }
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      await this.getRecmendDetail(this.$route.query.id)
    }
    if (this.$hasPermission('pms:admin:property:list')) {
      // 获取产品性质
      // this.getProNature()
    }
  },
  methods: {
    imageLoad (a, img, index) {
      console.log('this.$refs', this.$refs[`imgSize${index}`])
      if (this.$refs[`imgSize${index}`]) {
        let _o = this.$refs[`imgSize${index}`]
        console.log('_o', _o[0].imageHeight)
        // 比例
        let proportion = _o[0].imageHeight / 100
        this.previewUrlList[index].height = _o[0].imageHeight
        this.previewUrlList[index].realyWidth = _o[0].imageWidth * proportion
        this.previewUrlList[index].proportion = proportion
      }
      console.log('his.form.previewUrl', this.previewUrlList)
      // console.log('aaaaa', img)
      // let imgDetail = this.datadragEnd(img)
      // console.log('imgDetail', imgDetail)
      // this.previewUrlList[index].height = imgDetail.height
      // this.previewUrlList[index].width = imgDetail.width
    },
    // 获取图片宽高
    datadragEnd (imgurl) {
      // 创建实例对象
      var img = new Image()
      // 图片地址
      img.src = imgurl
      let res = {}
      img.onload = function () {
        res = {
          width: img.width,
          height: img.height
        }
        console.log('获取到图片的宽高', res) // 获取到图片的宽高
      }
      return res
    },
    // 搜索产品
    filterMethod (val, i) {
      if (val.trim()) {
        let param = {
          name: val,
          storeId: process.env.NODE_ENV === 'production' ? 191803 : 190086,
          type: this.form.productList[i].productType,
          isZeroPurchase: false
        }
        getRelatesInfo(param).then(res => {
          if (res.data.success) {
            this.tableDataList[i].list = res.data.data
          }
        })
      }
    },
    // 选择产品
    handleChange (val, i) {
      this.form.productList[i].productId = val.id
      this.form.productList[i].productInfo = val.name
    },
    // 获取详情
    async getRecmendDetail (bannerId) {
      await getInfoRecmendById(bannerId).then(res => {
        if (res.data.success) {
          let previewUrl = res.data.data.previewUrl ? res.data.data.previewUrl.split(',') : []
          this.previewUrlList = previewUrl.map(a => {
            return {
              url: a
            }
          })
          this.form.productList = res.data.data.productList.map(a => {
            return {
              ...a,
              productUrl: a.productUrl ? [{ url: a.productUrl }] : []
            }
          })
          this.tableDataList = this.form.productList.map(a => {
            return {
              list: []
            }
          })
          // this.form.bannerUrl = [{ url: res.data.data.bannerUrl }]
          // this.form.detailsUrl = res.data.data.detailsUrl.split(',').map(a => {
          //   return {
          //     url: a
          //   }
          // })
          console.log(' this.form.', this.form)
        }
      })
    },
    removeAppImage (e, i) {
      let imgurl = this.form.productList[i].productUrl[0].url // 获取到删除的url
      let itemIndex = this.previewUrlList.findIndex((value) => value.url == imgurl)
      console.log('indexxxxx', itemIndex)
      this.previewUrlList.splice(itemIndex, 1)
      this.form.productList[i].productUrl = []
    },
    showAppImagePreview (type) {
      this.showImgPreview = true
      this.previewImage = this.form.bannerUrl
    },
    uploadAppImage (e, i) {
      console.log('eeee', e)
      if (e.file.size > 1024 * 1024 * 10) {
        this.$message.error('图片大小不能超过10M')
        return
      }
      uploadWebImg(e.file, this.$store.state.awsSdk.product.s3).then(res => {
        if (res) {
          let that = this
          // 创建实例对象
          var img = new Image()
          // 图片地址
          img.src = res
          img.onload = function () {
            console.log('获取到图片的宽高', img.height, img.width, that.previewUrlList) // 获取到图片的宽高
            // if (img.width > 360) {
            //   that.$refs[`uploadFile${i}`][0].uploadFiles = []
            //   that.$message.error('满了')
            //   return
            // }
            if (that.previewUrlList.length > 0 && img.height != that.previewUrlList[0].height) {
              // 清空默认展示的图片
              that.$refs[`uploadFile${i}`][0].uploadFiles = []
              that.$message.error('图片高度不一致！')
              return
            }
            // if (that.previewUrlList.length > 0) {
            //   let width = 0
            //   that.previewUrlList.forEach(e => {
            //     width = width + (e.realyWidth + 5)
            //   })
            //   console.log('width', width, (img.width + 5) * that.previewUrlList[0].proportion)
            //   let allwidth = width + ((img.width + 5) * that.previewUrlList[0].proportion)
            //   console.log('allwidth', allwidth)
            //   if (allwidth > 360) {
            //     that.$refs[`uploadFile${i}`][0].uploadFiles = []
            //     that.$message.error('满了')
            //     return
            //   }
            // }
            that.form.productList[i].productUrl.push({ url: res })
            that.previewUrlList.push({ url: res })
            that.showPcImage = false
          }
          // this.$refs.form.validateField('bannerUrl')
        } else {
          this.$message.error('图片上传失败')
        }
      })
    },
    save () {
      console.log('this.previewUrlList', this.previewUrlList)
      let previewUrl = this.previewUrlList.map(a => {
        return a.url
      })
      this.form.previewUrl = previewUrl.toString()
      let productList = this.form.productList.filter(a => a.productUrl.length > 0)
      console.log('productList', productList)
      this.form.productList = productList.map((a, i) => {
        delete a.updateTime
        delete a.createTime
        return {
          ...a,
          productUrl: a.productUrl[0] ? a.productUrl[0]?.url : '',
          sort: i + 1
        }
      })
      console.log(' this.form.productList ', this.form.productList)
      if (!this.form.id) {
        appRecmendSave(this.form).then(res => {
          if (res.data.success) {
            this.$notify({
              title: '成功',
              message: '保存成功',
              type: 'success'
            })
            this.$router.go(-1)
          }
        }
        )
      } else {
        updateRecmendById(this.form).then(res => {
          if (res.data.success) {
            if (res.data.success) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              })
              this.$router.go(-1)
            }
          }
        })
      }
    },
    // 继续添加
    continueAdd () {
      this.form.productList.push({
        productId: 0,
        productInfo: '',
        productType: '',
        productUrl: []
      })
      this.tableDataList.push({ list: [] })
    }
  }
}
</script>

<style scoped lang="less">
@deep: ~">>>";

/deep/ .el-upload-list__item-thumbnail {
  // width: auto !important;
  object-fit: scale-down;
}

@{deep} .pc_detail {
  width: 100%;

  img {
    width: 100%;
  }
}

@{deep} .hide_uploadbtn .el-upload--picture-card {
  display: none;
  /* 上传按钮隐藏 */
}

// @{deep} .ql-container .ql-snow {
//   height: 500px;
// }
@{deep} .ql-container {
  height: auto !important;
}

.quill-editor {
  width: 70%;

  @{deep} .ql-editor {
    min-height: 400px;
  }

  @{deep} .ql-toolbar {
    .ql-picker-label {
      height: auto;
    }

    .ql-picker.ql-expanded .ql-picker-options {
      top: auto;
    }
  }
}

@{deep} .el-cascader {
  line-height: 0;
}
</style>
